import { Box, Grid, useTheme } from "@mui/material";
import React from "react";
import { Base } from "../../base";
import JobTime from "../../../types/jobTime";
import { Delete } from "@mui/icons-material";
import moment from "moment";
import { useSelector } from "../../../store";

interface Props {
  time: JobTime;
  setDeleteHourModal?: React.Dispatch<
    React.SetStateAction<{
      id: number;
      note?: string | undefined;
    }>
  >;
}

const JobHoursDisplay: React.FC<Props> = (props) => {
  const { time, setDeleteHourModal } = props;
  const theme = useTheme();
  const { loggedInUser } = useSelector((store) => store.authentication);
  const { simpleUserList } = useSelector((store) => store.user);

  return (
    <Grid
      container
      direction={"column"}
      sx={{
        backgroundColor: theme.palette.background.default,
        paddingX: "10px",
        borderRadius: "10px",
      }}
      marginBottom={2}
    >
      <Grid sx={{ borderBottom: "1px solid black" }}>
        <Grid
          container
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ py: "5px" }}
        >
          <Grid>
            <Base.Text
              text={`${time.category?.value} | Worked by ${
                simpleUserList.find((u) => u.id === time.workedById)?.value
              } on ${moment(time.workedOn).format("MM/DD/YY")}: ${
                time.hours
              } hrs`}
            />
          </Grid>
          <Grid>
            {setDeleteHourModal && time.workedById === loggedInUser?.id && (
              <Base.IconButton
                icon={<Delete />}
                label="Delete"
                onClick={() => setDeleteHourModal({ id: time.id })}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid sx={{ paddingY: "10px" }}>
        {time.note.split("\n").map((t, key) => (
          <Box key={key}>
            <Base.Text text={t} />
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default JobHoursDisplay;
